import React from "react";
import { PageHero, SectionLabel, Reveal, ArrowLink } from "../components/common";
import { CtaBand } from "./Home";
import { IMG, AI_PILLARS, AI_LAYERS } from "../mock";

export default function AiPlatform() {
  return (
    <main>
      <PageHero
        index="03"
        eyebrow="A Garry Industries Ventures · Digital & AI Platform"
        title="A living, intelligent model of the railway."
        subtitle="Every machine we build is sensor-native. Together they feed a unified digital platform that turns raw field data into prediction, prevention and autonomy."
        image={IMG.dashboard}
      />

      {/* Pillars */}
      <section className="bg-[#0a0a0a] py-24 md:py-32">
        <div className="mx-auto max-w-[1400px] px-5 md:px-10">
          <Reveal><SectionLabel>A Garry Industries Ventures · Platform Pillars</SectionLabel></Reveal>
          <Reveal><h2 className="font-display mt-6 text-4xl md:text-5xl lg:text-6xl font-bold leading-[1.02] tracking-tight">Four capabilities, one system.</h2></Reveal>
          <div className="mt-16 grid gap-px bg-white/10 sm:grid-cols-2 lg:grid-cols-4">
            {AI_PILLARS.map((p, i) => (
              <Reveal key={i} delay={i * 70} className="group bg-[#0a0a0a] p-8 hover:bg-[#111] transition-colors">
                <div className="font-mono2 text-[#c3e63c] text-sm">{String(i + 1).padStart(2, "0")}</div>
                <h3 className="font-display mt-5 text-xl font-semibold">{p.title}</h3>
                <p className="mt-3 text-sm leading-relaxed text-neutral-400">{p.desc}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      {/* Command centre image */}
      <section className="relative overflow-hidden">
        <img src={IMG.analytics} alt="AI command centre digital twin" className="h-[360px] md:h-[520px] w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-[#0a0a0a] via-transparent to-[#0a0a0a]/40" />
        <div className="absolute bottom-0 left-0 right-0">
          <div className="mx-auto max-w-[1400px] px-5 md:px-10 pb-10">
            <div className="eyebrow text-[#c3e63c]">Command Centre · Digital Twin</div>
          </div>
        </div>
      </section>

      {/* Architecture */}
      <section className="bg-[#f2f1ec] text-[#0a0a0a] py-24 md:py-32">
        <div className="mx-auto max-w-[1400px] px-5 md:px-10">
          <div className="grid gap-8 lg:grid-cols-[1fr_1fr] lg:gap-20 lg:items-end">
            <div>
              <Reveal><SectionLabel light>A Garry Industries Ventures · Architecture</SectionLabel></Reveal>
              <Reveal><h2 className="font-display mt-6 text-4xl md:text-5xl lg:text-6xl font-bold leading-[1.02] tracking-tight">From edge to intelligence.</h2></Reveal>
            </div>
            <Reveal delay={100}><p className="text-[#4a4a44] leading-relaxed">A layered platform that scales from a single machine to an entire national fleet.</p></Reveal>
          </div>

          <div className="mt-16 space-y-px bg-[#d8d7d0] border border-[#d8d7d0]">
            {AI_LAYERS.map((l, i) => (
              <Reveal key={l.id} delay={i * 60} className="group grid grid-cols-[auto_1fr] md:grid-cols-[120px_240px_1fr] items-center gap-5 bg-[#f2f1ec] px-6 py-6 hover:bg-white transition-colors">
                <span className="font-mono2 text-[#8ba817] font-bold">{l.id}</span>
                <h3 className="font-display text-lg font-semibold">{l.title}</h3>
                <p className="col-span-2 md:col-span-1 text-sm text-[#4a4a44]">{l.desc}</p>
              </Reveal>
            ))}
          </div>
          <div className="mt-14"><ArrowLink to="/machines" light>See sensor-native machines</ArrowLink></div>
        </div>
      </section>

      <CtaBand />
    </main>
  );
}
